import { LOCALE } from "core/interfaces";

import { colorDenormalize, colorNormalize } from "~/common/helpers/color-adapter";
import { extractTranslation } from "~/common/helpers/extract-translation";
import type { Material, MaterialAdapted } from "~/common/interfaces/entities/material.interface";

export const materialDenormalize = (materialAdapted: MaterialAdapted): Material => {
	const { name: _name, colors, ...rest } = materialAdapted;

	return {
		colors: colors.map(colorAdapted => colorDenormalize(colorAdapted)),
		...rest
	};
};

export const materialNormalize = (locale: Ref<LOCALE>, material: Material): MaterialAdapted => {
	const { translations, colors, ...rest } = material;

	const translation = extractTranslation(locale.value, translations);

	return {
		name: translation ? translation.name : "NAME",
		translations,
		colors: colors ? colors.map(color => colorNormalize(locale, color)) : [],
		...rest
	};
};
